import {Component, OnInit, TemplateRef} from '@angular/core';
import {ApiService} from '../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UtilsService} from '../../core/services/utils/utils.service';
import {Entity} from '../../core/models/entities/entity';
import {DashboardService} from '../dashboard.service';
import {User} from '../../core/models/user';

export interface Quote {
  createdAt: number;
  updatedAt: number;
  id: string;
  person_id: string;
  quoteBy: QuoteBy;
  type: string;
  famous_quote: string;
  status: string;
  byAdmin: boolean;
  addedBy: any;
}

export interface QuoteBy {
  name: string;
}

export interface Quote {
  person_id: string;
  type: string;
  famous_quote: string;
}

@Component({
    selector: 'app-banners',
    templateUrl: './quotes.component.html',
    styleUrls: ['./quotes.component.css'],
    standalone: false
})
export class QuotesComponent implements OnInit {

  loading = true;
  page = 1;
  total = 0;
  loaders = Array(10).fill(0);
  perPage = 10;
  filters = {
    keyword: '',
    status: 'all',
    type: 'all',
    sortBy: 'created_desc'
  };

  // Quotes
  quote = {person_id: '', type: 'Entity', famous_quote: ''};
  lookupEntities: Entity[];
  lookupUsers: User[];
  quotesData: any;
  quotes: Quote[] = [];

  option: string;

  constructor(private api: ApiService,
              private toastr: ToastrService,
              private modalService: BsModalService,
              private utils: UtilsService,
              private dashApi: DashboardService) {
  }

  ngOnInit(): void {
    this.getEntities();
    this.getUsers();
    this.getAllQuotes();
  }

  getEntities(): void {
    this.dashApi.searchEntities({}).subscribe(res => {
      this.lookupEntities = res.response.entities;
    }, err => this.utils.resErr(err));
  }

  getUsers(): void {
    this.api.getAllUsers({page: 1, per_page: 100}).subscribe(res => {
      this.lookupUsers = res.response.users;
    }, err => this.utils.resErr(err));
  }

  buildQuotesFilterPayload(): any {
    const data: any = {};
    const keyword = (this.filters.keyword || '').trim();

    if (keyword) {
      data.keyword = keyword;
    }

    if (this.filters.type !== 'all') {
      data.type = this.filters.type;
    }

    if (this.filters.status !== 'all') {
      data.status = this.filters.status;
    }

    return data;
  }

  buildQuotesQuery(page: number = 1): any {
    return {
      page,
      per_page: this.perPage,
      sort_by: this.filters.sortBy
    };
  }

  getAllQuotes(newPage: number = 1): void {
    this.page = newPage;
    this.loading = true;
    this.api.getAllFamousQuote(this.buildQuotesFilterPayload(), this.buildQuotesQuery(newPage)).subscribe(res => {
      const response = res?.response || {};
      this.quotesData = response;
      this.quotes = response.quotes || [];
      this.total = response.totalCount || 0;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.utils.resErr(err);
    });
  }

  deleteQuote(id): void {
    if (confirm('Are you sure you want to delete this quote?')) {
      this.api.deleteFamousQuote(id).subscribe(res => {
        this.getAllQuotes(this.page);
        this.utils.toastSuccess('Quote deleted!!');
      }, err => this.utils.resErr(err));
    }
  }

  updateQuoteStatus(id: string, status: string): void {
    this.api.quotesStatusUpdate({status, id}).subscribe(res => {
      this.getAllQuotes(this.page);
    }, err => this.utils.resErr(err));
  }

  pageChange(event): void {
    this.page = event;
    this.loading = true;
    this.getAllQuotes(event);
    window.scrollTo(0, 0);
  }

  applyFilters(): void {
    this.getAllQuotes(1);
  }

  clearFilters(): void {
    this.filters = {
      keyword: '',
      status: 'all',
      type: 'all',
      sortBy: 'created_desc'
    };
    this.getAllQuotes(1);
  }

  hasActiveFilters(): boolean {
    return !!(this.filters.keyword || '').trim()
      || this.filters.status !== 'all'
      || this.filters.type !== 'all'
      || this.filters.sortBy !== 'created_desc';
  }

  handleFilterInputKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.applyFilters();
    }
  }
}
